import { MeterType } from "../enums/meter-type.enum";
import { TypeOfConnection } from "./customer.model";
import { MeterMakeForSelect } from "./meter.model";
import { OrganizationForSelect } from "./organization.model";

export class MeterPrice {
    id: number = 0;
    powerPhase: TypeOfConnection;
    price: number;
    utilityId: number = 0;
    friendlyPowerPhase: string;
    organization?: OrganizationForSelect;
    
}